const canApplyProStaffDiscount = (productTags, hasSalePrice) =>
  productTags?.includes('prostaff_eligible') && !hasSalePrice;

export default canApplyProStaffDiscount;
